module.exports = __webpack_public_path__ + "fonts/inter-v11-latin-900.0b5eab4.ttf";